import { gql } from '@apollo/client';

export const SEARCH_OUTBOUND_INTERFACE = gql`
  query SearchOutboundInterfaces($searchInput: SearchInput) {
    searchOutboundInterfaces(searchInput: $searchInput) {
      items {
        id
        createdDate
        errorType
        message
        outboundAction
        response
        status
        createdBy
        updatedDate
        toolOrder {
          id
          orderNumber
        }
        toolCheckIn {
          id
          checkInNumber
        }
        toolTransfer {
          id
          toolTransferNumber
        }
      }
    }
  }
`;
export const RESYNC_FAILED_OUTBOUND = gql`
  mutation RetryOutboundInterface($retryOutboundInterfaceInput: RetryOutboundInterfaceInput!) {
    retryOutboundInterface(retryOutboundInterfaceInput: $retryOutboundInterfaceInput) {
      errors
      outboundInterface {
        id
        message
        outboundAction
        projectId
        referenceId
        response
        status
        errorType
      }
    }
  }
`;
export const GET_OUTBOUND_INTERFACE_COUNT = gql`
  query Query($searchInput: SearchInput) {
    outboundInterfaceCount(searchInput: $searchInput)
  }
`;
